import { useUpdateEntityApi } from '@/common/api/updateEntityApi';
import type { Packaging } from 'shared/packages/domain/packaging';
import type { PackagingLevel } from 'shared/packages/domain/packagingLevel';
import { usePackagingStore } from 'shared/packages/stores/packagingStore';

export interface UpdatePackaging {
  name: string;
  description: string;
  level: PackagingLevel;
}

export interface UpdatePackagingResponse {
  ok: true;
  packaging: Packaging;
}

export function useUpdatePackaging() {
  const store = usePackagingStore();

  return useUpdateEntityApi<UpdatePackaging, UpdatePackagingResponse>({
    url: 'packaging',
    translate: (t) => t.packaging.actions.update,
    async processOk(response) {
      const json = await response.json() as Packaging;
      store.add(json);
      return {
        ok: true,
        packaging: json,
      };
    },
  });
}
